import { CircularProgress, Typography } from "@material-ui/core";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import AvailabilitySelectableBox from "../availability_box/AvailabilitySelectableBox";
import { SessionMenuItem } from "../../models/session";
import { convertTimeSlotTimestamp, isTimeSlotSelected } from "../../helpers/timeSlotHelper";
import { IAvailability } from "../../models";
import { useEffect } from "react";
import './index.scss';

interface Props{
    selectTimeSlot: (availability: IAvailability) => Promise<void>
}

export const TimeSlots = ({selectTimeSlot}: Props) => {
  const hasTimeSlotSelection = useSelector((state: RootState) => state.session.session?.service_type?.has_time_slots ?? true);
  const availabilities = useSelector((state: RootState) => state.availability.slots);
  const deliveryMode = useSelector((state: RootState) => state.session.session?.delivery_mode ?? null);
  const ditsMenuItems = useSelector((state: RootState) => state.session.menuItems);
  const selectedTimeSlot = useSelector((state: RootState) => state.session.session?.time_slot);

  const ditsMenuItemsWeight = ditsMenuItems?.reduce((acc:number, item: SessionMenuItem) => acc += item.prepare_weight ?? 1, 0);

  useEffect(() => {
    if (!!availabilities && hasTimeSlotSelection) {
      const hasTimeSlot = !!selectedTimeSlot;
      if (hasTimeSlot && !!availabilities && availabilities.length > 0) {
        const timeStart = selectedTimeSlot?.start ?? null;
        if(timeStart){
          const id = `availability-box-${timeStart}`;
          const elemenToScroll = document.getElementById(id);
          if(elemenToScroll){
            elemenToScroll.scrollIntoView({ behavior: 'auto',
              block: 'center',
              inline: 'center' 
            });
          }
        }
      }
    }
  }, [availabilities]);

  if(!hasTimeSlotSelection) return null;

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-left">
            <Typography variant="h4" gutterBottom align="left" className="recap-header">
              {LocalizerHelper.localized('time_slots')}
            </Typography>
          </div>
        </div>
      </div>
      <div className="container availabilities-container">
        <div className="row">
          {availabilities.map((availability, index) => {
            return <AvailabilitySelectableBox 
              availability={convertTimeSlotTimestamp(availability)} 
              ditsMenuItemsWeight={ditsMenuItemsWeight ?? 0}
              deliveryMode={deliveryMode}
              selectTimeSlot={selectTimeSlot}
              selected={isTimeSlotSelected(selectedTimeSlot, convertTimeSlotTimestamp(availability))}
              key={`availability-box-${availability?.timeStart}-${index}`}
            />
          })}
        </div>
      </div> 

    </div>
  );
};
